import { FC } from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "../layouts/_layout";
import routes from "../config/routes";
import PrivateRoute from "../lib/private-route";
import { permissions } from "../lib/constants";
import SignInPage from "../pages/authentication/sign-in";
import NotFound from "../pages/404";
import DashboardPage from "src/pages/dashboard";
import UserManagementPage from "src/pages/dashboard/user-management";
import CurrencyManagementPage from "src/pages/dashboard/currency-management";
import NotificationManagementPage from "src/pages/dashboard/notification-management";
import TransactionsManagementPage from "src/pages/dashboard/transactions-management";
import PendingDepositsPage from "src/pages/dashboard/pending-deposits";
import PendingWithdrawalsPage from "src/pages/dashboard/pending-withdrawals";
import SettingsPage from "src/pages/dashboard/settings";
import AdminsManagementPage from "src/pages/dashboard/admins-management";
import AdminManageWhiteLabelPage from "src/pages/dashboard/admin-manage-white-label";
import BankAccountPage from "src/pages/dashboard/bank-account";
import FastTransferPage from "../pages/dashboard/fast-transfer";
import OurPrices from "src/pages/dashboard/our-prices";
import UnidentifiedDeposits from "src/pages/dashboard/unidentifiedDeposits";
import Reset2FAPage from "src/pages/dashboard/reset2fa";
import SmsHistoryPage from "src/pages/dashboard/smsHistory";
import EmailHistoryPage from "src/pages/dashboard/emailHistory";
import FeeMgt from "src/pages/dashboard/fee-mgt";
import FeeMgtBusiness from "src/pages/dashboard/fee-mgt-business";
import LimitationsManagement from "src/pages/dashboard/limitations-management";
import BusinessLimitationsManagement from "src/pages/dashboard/limitation-business-management";
import ProfilePage from "src/pages/dashboard/profile";
import ProfileTwoFAPage from "src/pages/dashboard/profile-2fa";
import ProfileChangePasswordPage from "src/pages/dashboard/profile-change-password";
import Categories from "src/components/moneyMoversMgt/categories";
import Services from "src/components/moneyMoversMgt/services";
import CashoutServices from "src/components/moneyMoversMgt/cashoutServices";
// import Translation from "src/pages/dashboard/translation";
import Conversion from "src/pages/dashboard/conversion";
import WebTranslation from "src/components/translation/web";
import MobileTranslation from "src/components/translation/mobile";
import BackendTranslation from "src/components/translation/backend";

import Provider from "src/pages/dashboard/Provider";
import SelfTerminalTransactions from "src/components/self-terminal/transactions";
import AdminActivity from "src/pages/dashboard/admin-activity";
import AdminAlerts from "src/pages/dashboard/adminAlerts";
import ManualTransfer from "src/pages/dashboard/ManualTransfer";
import ActivityLogs from "src/pages/dashboard/admin-activity-logs";
import EmailTemplate from "src/pages/dashboard/email-template";
import WalletTerminal from "src/pages/dashboard/WalletTerminal";
import ServiceMaintenance from "src/pages/dashboard/ServiceMaintenance";
import ServiceAlerts from "src/pages/dashboard/ServiceAlerts";
import ServiceIncidents from "src/pages/dashboard/ServiceIncidents";
import CardPackages from "src/pages/dashboard/CardPackages";
import CardPackageForm from "src/pages/dashboard/CardPackageForm";
import VirtualCardMerchants from "src/pages/dashboard/virtual-card-merchants";
import CardConversions from "src/pages/dashboard/virtual-card-conversions";
import VirtualCardsMerchantView from "src/pages/dashboard/virtual-card-merchants-view";
import CardConversionHistory from "src/pages/dashboard/virtual-card-conversion-history";
import CardAllTransactions from "src/pages/dashboard/virtual-card-transactions";
import CardTypes from "src/pages/dashboard/CardTypes";
import CardTypeForm from "src/pages/dashboard/CardTypeForm";
import CardPoolManagement from "src/pages/dashboard/virtual-card-pool-management";
import VirtualOrderedCardsList from "src/pages/dashboard/virtual-card-ordered-cards-list";
import VirtualCardKakfaNotifications from "src/pages/dashboard/virtual-card-kakfa-notifications";
import FaqManagement from "src/pages/dashboard/LandingPage/FaqManagement";
import BlogPostsManagement from "src/pages/dashboard/LandingPage/BlogPostsManagement";
import PaymentsTransactionHistory from "src/pages/dashboard/transactionsPaymentsHistory";
import PaymentsTransactionHistoryBusiness from "src/pages/dashboard/transactionsPaymentHistoryBusiness";
import ExportsHistory from "src/pages/dashboard/transactionsPaymentsExportHistory";
import CardProducts from "src/pages/dashboard/CardProducts";
import CardProductsForm from "src/pages/dashboard/CardProductsForm";
import CardTermsConditions from "src/pages/dashboard/CardTermsConditions";
import CardTermsConditionsForm from "src/pages/dashboard/CardTermsConditionsForm";
import CardBillings from "src/pages/dashboard/CardBillings";
import ManageRolesPermissionPage from "src/pages/dashboard/manage-roles-permission";
import PermissionsManagementPage from "src/pages/dashboard/permissions-management";
import MtsTransferLogs from "src/pages/dashboard/transactionsMtsLogs";
import ManageChannelPartnersPage from "src/pages/dashboard/manage-channel-partners";
import KafkaSyncHistory from "src/pages/dashboard/KafkaSyncHistory";

const AppRoutes: FC = () => {
  return (
    <Layout>
      <Routes>
        <Route index element={<SignInPage />} />
        <Route path="*" element={<NotFound />} />
        <Route
          path={routes.dashboard}
          element={
            <PrivateRoute permissions={[permissions.DASHBOARD]}>
              <DashboardPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.users}
          element={
            <PrivateRoute
              permissions={[
                permissions.USER_MANAGEMENT_INDIVIDUAL_USERS,
              ]}
            >
              <UserManagementPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.userItem}
          element={
            <PrivateRoute
              permissions={[
                permissions.USER_MANAGEMENT_INDIVIDUAL_USERS,
              ]}
            >
              <UserManagementPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.usersBusiness}
          element={
            <PrivateRoute
              permissions={[
                permissions.USER_MANAGEMENT_BUSINESS_USERS,
              ]}
            >
              <UserManagementPage isBuisiness />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.usersBusinessItem}
          element={
            <PrivateRoute
              permissions={[
                permissions.USER_MANAGEMENT_BUSINESS_USERS,
              ]}
            >
              <UserManagementPage isBuisiness />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.feeManagement}
          element={
            <PrivateRoute
              permissions={[permissions.FEE_MANAGEMENT_INDIVIDUAL]}
            >
              {/* <FeeManagementPage /> */}
              <FeeMgt />
            </PrivateRoute>
          }
        />

        <Route
          path={routes.moneyMoverCategories}
          element={
            <PrivateRoute permissions={[permissions.MONEY_MOVER_CATEGORIES]}>
              <Categories />
            </PrivateRoute>
          }
        />

        <Route
          path={routes.moneyMoverCategories}
          element={
            <PrivateRoute permissions={[permissions.MONEY_MOVER]}>
              <Categories />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.moneyMoverServices}
          element={
            <PrivateRoute permissions={[permissions.MONEY_MOVER]}>
              <Services />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.adminActivity}
          element={
            <PrivateRoute permissions={[permissions.MANAGE_ADMIN]}>
              <AdminActivity />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.activityLogs}
          element={
            <PrivateRoute permissions={[permissions.MANAGE_ADMIN]}>
              <ActivityLogs />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.walletTerminal}
          element={
            <PrivateRoute permissions={[permissions.WALLET_TERMINAL]}>
              <WalletTerminal />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.moneyMoverCasinoServices}
          element={
            <PrivateRoute permissions={[permissions.MONEY_MOVER]}>
              <CashoutServices />
            </PrivateRoute>
          }
        />

        <Route
          path={routes.moneyMoverServices}
          element={
            <PrivateRoute permissions={[permissions.MONEY_MOVER_SERVICES]}>
              <Services />
            </PrivateRoute>
          }
        />

        <Route
          path={routes.profile}
          element={
            <PrivateRoute>
              <ProfilePage />
            </PrivateRoute>
          }
        />

        <Route
          path={routes.adminActivity}
          element={
            <PrivateRoute permissions={[permissions.MANAGE_ADMIN]}>
              <AdminActivity />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.activityLogs}
          element={
            <PrivateRoute permissions={[permissions.ACTIVITY_LOGS]}>
              <ActivityLogs />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.walletTerminal}
          element={
            <PrivateRoute permissions={[permissions.WALLET_TERMINAL]}>
              <WalletTerminal />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.moneyMoverCasinoServices}
          element={
            <PrivateRoute permissions={[permissions.MONEY_MOVER_CASINO_CASHOUT]}>
              <CashoutServices />
            </PrivateRoute>
          }
        />

        <Route
          path={routes.feeManagementBusiness}
          element={
            <PrivateRoute
              permissions={[permissions.FEE_MANAGEMENT_BUSINESS]}
            >
              {/* <FeeManagementBusinessPage /> */}
              <FeeMgtBusiness />
            </PrivateRoute>
          }
        />

        <Route
          path={routes.profile}
          element={
            <PrivateRoute>
              <ProfilePage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.profileTwoFA}
          element={
            <PrivateRoute>
              <ProfileTwoFAPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.profileChangePassword}
          element={
            <PrivateRoute>
              <ProfileChangePasswordPage />
            </PrivateRoute>
          }
        />

        <Route
          path={routes.currency}
          element={
            <PrivateRoute permissions={[permissions.CURRENCY]}>
              <CurrencyManagementPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.notification}
          element={
            <PrivateRoute permissions={[permissions.NOTIFICATIONS]}>
              <NotificationManagementPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.adminAlerts}
          element={
            <PrivateRoute permissions={[permissions.ADMIN_ALERT]}>
              <AdminAlerts />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.emailTemplate}
          element={
            <PrivateRoute permissions={[permissions.EMAIL_TEMP]}>
              <EmailTemplate />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.transactions}
          element={
            <PrivateRoute
              permissions={[permissions.TRANSACTION_HISTORY_INDIVIDUAL]}
            >
              <TransactionsManagementPage />
              {/* <PaymentsTransactionHistory /> */}
            </PrivateRoute>
          }
        />
        <Route
          path={routes.transactionsBusiness}
          element={
            <PrivateRoute
              permissions={[permissions.TRANSACTION_HISTORY_BUSINESS]}
            >
              {/* <PaymentsTransactionHistoryBusiness /> */}
              <TransactionsManagementPage isBuisiness />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.updatedtransactions}
          element={
            <PrivateRoute
              permissions={[permissions.TRANSACTION_HISTORY_NEW_INDIVIDUAL]}
            >
              {/* <TransactionsManagementPage /> */}
              <PaymentsTransactionHistory />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.updatedtransactionsBusiness}
          element={
            <PrivateRoute
              permissions={[permissions.TRANSACTION_HISTORY_NEW_BUSINESS]}
            >
              <PaymentsTransactionHistoryBusiness />
              {/* <TransactionsManagementPage isBuisiness /> */}
            </PrivateRoute>
          }
        />
        <Route
          path={routes.mtsTransferLogs}
          element={
            <PrivateRoute permissions={[permissions.TRANSACTIONS]}>
              <MtsTransferLogs />
              {/* <TransactionsManagementPage isBuisiness /> */}
            </PrivateRoute>
          }
        />
        <Route
          path={routes.exportsList}
          element={
            <PrivateRoute permissions={[permissions.EXPORT_HISTORY]}>
              <ExportsHistory />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.pendingDeposit}
          element={
            <PrivateRoute
              permissions={[permissions.PENDING_DEPOSIT_INDIVIDUAL]}
            >
              <PendingDepositsPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.pendingDepositBuisiness}
          element={
            <PrivateRoute
              permissions={[permissions.PENDING_DEPOSIT_BUSINESS]}
            >
              <PendingDepositsPage isBuisiness />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.pendingWithdrawals}
          element={
            <PrivateRoute
              permissions={[permissions.PENDING_WITHDRAWALS_INDIVIDUAL]}
            >
              <PendingWithdrawalsPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.pendingWithdrawalsBuisiness}
          element={
            <PrivateRoute
              permissions={[permissions.PENDING_WITHDRAWALS_BUSINESS]}
            >
              <PendingWithdrawalsPage isBuisiness />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.limitations}
          element={
            <PrivateRoute
              permissions={[permissions.LIMITATIONS_INDIVIDUAL]}
            >
              {/* <LimitationsPage /> */}
              <LimitationsManagement />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.limitationsMoneyMoversIndividual}
          element={
            <PrivateRoute
              permissions={[permissions.LIMITATIONS_MONEY_MOVERS_INDIVIDUAL]}
            >
              <LimitationsManagement isMoneyMovers />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.limitationsBusiness}
          element={
            <PrivateRoute
              permissions={[permissions.LIMITATION_BUSINESS]}
            >
              {/* <LimitationsBusinessPage /> */}
              <BusinessLimitationsManagement />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.limitationsMoneyMoversBusiness}
          element={
            <PrivateRoute
              permissions={[permissions.LIMITATIONS_MONEY_MOVERS_BUSINESS]}
            >
              <BusinessLimitationsManagement isMoneyMovers />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.bankAccounts}
          element={
            <PrivateRoute permissions={[permissions.BANK_ACCOUNTS]}>
              <BankAccountPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.reset2FA}
          element={
            <PrivateRoute
              permissions={[permissions.USER_MANAGEMENT_2FA_RESET_REQUEST]}
            >
              <Reset2FAPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.emailHistory}
          element={
            <PrivateRoute permissions={[permissions.USER_MANAGEMENT_EMAIL]}>
              <EmailHistoryPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.smsHistory}
          element={
            <PrivateRoute
              permissions={[permissions.USER_MANAGEMENT_SMS]}
            >
              <SmsHistoryPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.ourPrices}
          element={
            <PrivateRoute permissions={[permissions.OUR_PRICES]}>
              <OurPrices />
            </PrivateRoute>
          }
        />
        {/* <Route
          path={routes.translation}
          element={
            <PrivateRoute permissions={[permissions.OUR_PRICES]}>
              <Translation />
            </PrivateRoute>
          }
        /> */}
        <Route
          path={routes.translation}
          element={
            <PrivateRoute permissions={[permissions.TRANSLATION_WEB]}>
              <WebTranslation />
            </PrivateRoute>
          }
        />

        <Route
          path={routes.mobileTranslation}
          element={
            <PrivateRoute permissions={[permissions.TRANSLATION_MOBILE]}>
              <MobileTranslation />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.backendTranslation}
          element={
            <PrivateRoute permissions={[permissions.TRANSLATION_BACKEND]}>
              <BackendTranslation />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.Conversion}
          element={
            <PrivateRoute permissions={[permissions.CONVERSION]}>
              <Conversion />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.settings}
          element={
            <PrivateRoute permissions={[permissions.SETTINGS]}>
              <SettingsPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.admins}
          element={
            <PrivateRoute permissions={[permissions.ADMIN_MANAGEMENT]}>
              <AdminsManagementPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.adminManageWhiteLabel}
          element={
            <PrivateRoute permissions={[permissions.ADMIN_MANAGEMENT]}>
              <AdminManageWhiteLabelPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.adminManageWhiteLabelItem}
          element={
            <PrivateRoute permissions={[permissions.ADMIN_MANAGEMENT]}>
              <AdminManageWhiteLabelPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.roles}
          element={
            <PrivateRoute permissions={[permissions.ROLES_PERMISSIONS]}>
              <ManageRolesPermissionPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.permissions}
          element={
            <PrivateRoute permissions={[permissions.PERMISSIONS]}>
              <PermissionsManagementPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.channelPartners}
          element={
            <PrivateRoute permissions={[permissions.MANAGE_CHANNEL_PARTNERS]}>
              <ManageChannelPartnersPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.fastTransfer}
          element={
            <PrivateRoute>
              <FastTransferPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.unidentifiedDeposits}
          element={
            <PrivateRoute
              permissions={[permissions.MANAGE_UNIDENTIFIED_DEPOSITS]}
            >
              <UnidentifiedDeposits />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.provider}
          element={
            <PrivateRoute permissions={[permissions.SELF_TERMINAL]}>
              <Provider />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.providerTransaction}
          element={
            <PrivateRoute permissions={[permissions.SELF_TERMINAL]}>
              <SelfTerminalTransactions />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.individualmanualTransfers}
          element={
            <PrivateRoute permissions={[permissions.MANUAL_TRANSACTIONS_INDIVIDUAL]}>
              <ManualTransfer />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.businessmanualTransfers}
          element={
            <PrivateRoute permissions={[permissions.MANUAL_TRANSACTIONS_BUSINESS]}>
              <ManualTransfer isBuisiness />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.serviceMaintenance}
          element={
            <PrivateRoute permissions={[permissions.SERVICE_MAINTENANCES]}>
              <ServiceMaintenance />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.serviceAlerts}
          element={
            <PrivateRoute permissions={[permissions.SERVICE_ALERTS]}>
              <ServiceAlerts />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.serviceIncidents}
          element={
            <PrivateRoute permissions={[permissions.SERVICE_INCIDENTS]}>
              <ServiceIncidents />
            </PrivateRoute>
          }
        />
        {/* <Route
          path={routes.cardPackages}
          element={
            <PrivateRoute permissions={[permissions.CARD_MANAGEMENT]}>
              <CardPackages />
            </PrivateRoute>
          }
        /> */}
        <Route
          path={routes.cardTypes}
          element={
            <PrivateRoute permissions={[permissions.CARD_DESIGN]}>
              <CardTypes />
            </PrivateRoute>
          }
        />

        <Route
          path={routes.cardBillings}
          element={
            <PrivateRoute permissions={[permissions.CARD_BILLINGS]}>
              <CardBillings />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.kafkaSyncHistory}
          element={
            <PrivateRoute permissions={[permissions.CARD_KAFKA_SYNC_HISTORY]}>
              <KafkaSyncHistory />
            </PrivateRoute>
          }
        />
        {/* <Route
       
        <Route
          path={routes.cardPackageForm}
          element={
            <PrivateRoute permissions={[permissions.CARD_MANAGEMENT]}>
              <CardPackageForm />
            </PrivateRoute>
          }
        /> */}
        {/* <Route
          path={routes.cardPackageEditForm}
          element={
            <PrivateRoute permissions={[permissions.CARD_MANAGEMENT]}>
              <CardPackageForm />
            </PrivateRoute>
          }
        /> */}

        <Route
          path={routes.cardProducts}
          element={
            <PrivateRoute permissions={[permissions.CARD_PRODUCTS]}>
              <CardProducts />
            </PrivateRoute>
          }
        />

        <Route
          path={routes.cardProductForm}
          element={
            <PrivateRoute permissions={[permissions.CARD_PRODUCTS]}>
              <CardProductsForm />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.cardProductEditForm}
          element={
            <PrivateRoute permissions={[permissions.CARD_PRODUCTS]}>
              <CardProductsForm />
            </PrivateRoute>
          }
        />

        <Route
          path={routes.cardTermsConditions}
          element={
            <PrivateRoute permissions={[permissions.CARD_TERMS_CONDITIONS]}>
              <CardTermsConditions />
            </PrivateRoute>
          }
        />

        <Route
          path={routes.cardTermsConditionsForm}
          element={
            <PrivateRoute permissions={[permissions.CARD_TERMS_CONDITIONS]}>
              <CardTermsConditionsForm />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.cardTermsConditionsEditForm}
          element={
            <PrivateRoute permissions={[permissions.CARD_TERMS_CONDITIONS]}>
              <CardTermsConditionsForm />
            </PrivateRoute>
          }
        />

        <Route
          path={routes.cardTypeForm}
          element={
            <PrivateRoute permissions={[permissions.CARD_DESIGN]}>
              <CardTypeForm />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.cardTypeEditForm}
          element={
            <PrivateRoute permissions={[permissions.CARD_DESIGN]}>
              <CardTypeForm />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.cardMerchants}
          element={
            <PrivateRoute permissions={[permissions.CARD_MERCHANTS]}>
              <VirtualCardMerchants />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.cardMerchantsView}
          element={
            <PrivateRoute permissions={[permissions.CARD_MERCHANTS]}>
              <VirtualCardsMerchantView />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.cardConversionList}
          element={
            <PrivateRoute permissions={[permissions.CARD_CONVERSION_RATES]}>
              <CardConversions />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.cardConversionSyncHistory}
          element={
            <PrivateRoute permissions={[permissions.CARD_CONVERSION_RATES_HISTORY]}>
              <CardConversionHistory />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.cardAllTransactions}
          element={
            <PrivateRoute permissions={[permissions.CARD_TRANSACTIONS]}>
              <CardAllTransactions />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.cardPool}
          element={
            <PrivateRoute permissions={[permissions.CARD_POOL]}>
              <CardPoolManagement />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.orderedCardHistory}
          element={
            <PrivateRoute permissions={[permissions.ORDERED_CARDS_HISTORY]}>
              <VirtualOrderedCardsList />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.kafkaNotifications}
          element={
            <PrivateRoute permissions={[permissions.CARD_KAFKA_NOTIFICATION]}>
              <VirtualCardKakfaNotifications />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.manageFaqs}
          element={
            <PrivateRoute permissions={[permissions.LANDING_PAGE_MANAGEMENT_FAQ]}>
              <FaqManagement />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.manageBlogs}
          element={
            <PrivateRoute permissions={[permissions.LANDING_PAGE_MANAGEMENT_BLOG_POSTS]}>
              <BlogPostsManagement />
            </PrivateRoute>
          }
        />
      </Routes>
    </Layout>
  );
};

export default AppRoutes;
